import * as React from "react";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";

export interface ToggleButton {
    key: string;
    label: string;
    element: React.ReactElement;
}

export interface ToggleButtonProps {
    selected?: string;
    onChange?: (key: string | null) => void;
    buttons: ToggleButton[];
}

export default function ToggleButtons({ buttons, selected, onChange }: ToggleButtonProps) {
    const handleAlignment = (event: React.MouseEvent<HTMLElement>, newValue: string | null) => {
        onChange?.(newValue);
    };

    return (
        <ToggleButtonGroup value={selected} exclusive onChange={handleAlignment} aria-label="text alignment">
            {buttons.map(b => {
                return (
                    <ToggleButton key={b.key} value={b.key} aria-label={b.label}>
                        {b.element}
                    </ToggleButton>
                );
            })}
        </ToggleButtonGroup>
    );
}
